// Admin Layout
import { Outlet, Link, useLocation } from 'react-router-dom';

const adminNavLinks = [
  { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
  { path: '/admin/users', label: 'Users', icon: '👥' },
  { path: '/admin/bookings', label: 'Bookings', icon: '📅' },
  { path: '/admin/classes', label: 'Classes', icon: '🏃' },
  { path: '/admin/calendar', label: 'Calendar', icon: '🗓️' },
  { path: '/admin/pages', label: 'Pages', icon: '📄' },
  { path: '/admin/blog', label: 'Blog', icon: '📝' },
  { path: '/admin/ai-writer', label: 'AI Writer', icon: '🤖' },
  { path: '/admin/media', label: 'Media', icon: '🖼️' },
  { path: '/admin/settings', label: 'Settings', icon: '⚙️' }
];

export default function AdminLayout() {
  const location = useLocation();
  
  return (
    <div className="drawer lg:drawer-open">
      <input id="admin-drawer" type="checkbox" className="drawer-toggle" />
      <div className="drawer-content flex flex-col">
        <div className="navbar bg-base-200 shadow-sm">
          <div className="flex-none lg:hidden">
            <label htmlFor="admin-drawer" className="btn btn-square btn-ghost">☰</label>
          </div>
          <div className="flex-1">
            <Link to="/admin/dashboard" className="font-heading font-bold text-xl ml-4">Admin Panel</Link>
          </div>
        </div>
        <main className="p-4"><Outlet /></main>
      </div>
      <div className="drawer-side z-50">
        <label htmlFor="admin-drawer" className="drawer-overlay"></label>
        <aside className="w-64 min-h-screen bg-base-200">
          <div className="p-4">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-lg">EG</span>
              </div>
              <span className="font-heading font-bold">Elite Gymnastics</span>
            </Link>
            <ul className="menu">
              {adminNavLinks.map(link => (
                <li key={link.path}>
                  <Link to={link.path} className={location.pathname === link.path ? 'active' : ''}>
                    <span>{link.icon}</span> {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
}